import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IMediaItem } from '../../_shared/models/media/media-item.model';
import { ImageDataDb } from '../../_shared/data/image-data-db.data';
import { IMedia } from '../../_shared/models/media/media.model';
import { ImageData } from '../../_shared/models/image/image-data.model';
import { GridComponent } from '../../grid/grid.component';
import { ImageItemComponent } from '../media-item/image-item/image-item.component';
import { VideoItemComponent } from '../media-item/video-item/video-item.component';

import { CastPipe } from '../../_shared/pipes/cast.pipe';

@Component({
    selector: 'sirius-media',
    templateUrl: './media.component.html',
    styleUrls: ['./media.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GridComponent, ImageItemComponent, VideoItemComponent, CastPipe]
})
export class MediaComponent implements OnInit {
    @Input() config?: IMedia;
    @Input() mediaItem!: IMediaItem;
    @Input() showDescription = false;

    open = false;
    imageData?: ImageData;

    ngOnInit(): void {
        if (this.config) {
            this.mediaItem = this.config.item;
            this.showDescription = this.config.showAltText;
        }

        this.imageData = ImageDataDb.media.single;
    }
}
